import { makePersistent } from '../persistent/makePersistent';
import { getArtifactId } from '../utils';
import { getSchema } from '../schema/getSchema';
import { SchemaModel } from './SchemaModel';
import { ManagedStorage } from '../persistent/ManagedStorage';
import { loadBundle } from './utils/loadBundle';
import { partialSchemaToFull } from '../schema/partialSchemaToFull';
export class DebugPanel {
    constructor(settings, options = {}) {
        this.settings = settings;
        this.cleanupFunctions = [];
        this.keyboardListener = (event) => {
            // Ctrl + Alt + Shift + L
            if (event.keyCode === 76 &&
                event.altKey &&
                event.ctrlKey &&
                event.shiftKey) {
                if (!this.opened) {
                    this.open();
                }
                else {
                    this.close();
                }
            }
            // Esc
            if (this.opened &&
                event.keyCode === 27 &&
                !event.altKey &&
                !event.ctrlKey &&
                !event.shiftKey) {
                return this.close();
            }
        };
        this.options = Object.assign(Object.assign({ showGeneralInfo: true, version: process.env.ARTIFACT_VERSION || window.__CI_APP_VERSION__ }, options), { schema: new SchemaModel(options.schema
                ? partialSchemaToFull(options.schema, settings)
                : getSchema(settings) || {}) });
        this.state = this.createState();
    }
    get opened() {
        return this.state.opened;
    }
    set opened(value) {
        this.state.opened = value;
    }
    start() {
        window.addEventListener('keydown', this.keyboardListener);
        this.cleanupFunctions.push(() => {
            window.removeEventListener('keydown', this.keyboardListener);
        });
        if (this.opened) {
            this.open(true);
        }
    }
    async open(isRestored = false) {
        if (this.opened && !isRestored) {
            return;
        }
        this.opened = true;
        const panel = await this.getPanel();
        await panel.open(isRestored);
    }
    async close() {
        if (this.panel) {
            await this.panel.close();
        }
        this.opened = false;
    }
    async destroy() {
        if (this.panel) {
            await this.panel.destroy();
        }
        this.cleanupFunctions.forEach((fn) => fn());
    }
    async getPanel() {
        if (!this.panel) {
            const module = await loadBundle('DefaultPanel');
            const DefaultPanelCls = module.DefaultPanel;
            this.panel = new DefaultPanelCls({
                settings: this.settings,
                options: this.options,
                onClose: () => this.close(),
            });
        }
        return this.panel;
    }
    createState() {
        const options = {
            opened: false,
        };
        const artifactId = getArtifactId();
        return makePersistent(options, new ManagedStorage(`${artifactId}.DebugPanelState`));
    }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function appendScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Could not load ${src}`));
        script.src = src;
        document.head.appendChild(script);
    });
}
//# sourceMappingURL=DebugPanel.js.map